import { useMemo } from 'react';
import { useGameStore } from '../../simulation/store';
import { isNight } from '../../simulation/systems/time';

function vehicleColour(kind: string): string {
  if (kind === 'bus') {
    return '#b93631';
  }
  if (kind === 'delivery') {
    return '#f3c66f';
  }
  if (kind === 'ambulance') {
    return '#f6ead1';
  }
  if (kind === 'fire-engine') {
    return '#c94339';
  }
  return '#4f7d97';
}

export function VehiclesLayer() {
  const vehicles = useGameStore((state) => state.world.vehicles);
  const minuteOfDay = useGameStore((state) => state.time.minuteOfDay);
  const night = isNight(minuteOfDay);
  const visibleVehicles = useMemo(() => vehicles.slice(0, 240), [vehicles]);

  return (
    <group>
      {visibleVehicles.map((vehicle) => {
        const next = vehicle.route[(vehicle.routeIndex + 1) % Math.max(1, vehicle.route.length)];
        const current = vehicle.route[vehicle.routeIndex] ?? next;
        const angle = current && next ? Math.atan2(next.x - current.x, next.z - current.z) : 0;
        const length = vehicle.kind === 'bus' ? 0.52 : 0.32;

        return (
          <group key={vehicle.id} position={[vehicle.position.x, 0.13, vehicle.position.z]} rotation={[0, angle, 0]}>
            <mesh castShadow>
              <boxGeometry args={[0.2, 0.14, length]} />
              <meshStandardMaterial color={vehicleColour(vehicle.kind)} roughness={0.55} />
            </mesh>
            <mesh position={[0, 0.09, -length * 0.1]}>
              <boxGeometry args={[0.16, 0.07, length * 0.45]} />
              <meshStandardMaterial color="#d9edf1" roughness={0.3} />
            </mesh>
            {night ? (
              <>
                <pointLight position={[0.08, 0.02, length / 2]} color="#f6ead1" intensity={0.5} distance={1.8} />
                <pointLight position={[-0.08, 0.02, length / 2]} color="#f6ead1" intensity={0.5} distance={1.8} />
              </>
            ) : null}
          </group>
        );
      })}
    </group>
  );
}
